// extracted by mini-css-extract-plugin
export default {"container":"GqlWithLoader__container___Y94Ri","noScrollContainer":"GqlWithLoader__noScrollContainer___rgxdm"};